import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './IntroBannerWithBackground.module.scss'
import Container from '../../container/Container'
import Input from '../../ui/input/Input'
import { SvgSearch } from '../../ui/svg-icons'

function IntroBannerWithBackground({
  title,
  subtitle,
  backgroundColor,
  backgroundImage,
  whiteText,
  className,
  content,
  precontent,
  search,
  searchValue,
  handleSearch,
}) {
  return (
    <section
      className={classNames(styles.section, className)}
      style={{ backgroundColor }}
    >
      {backgroundImage && (
        <div className={styles.backgroundImage}>{backgroundImage}</div>
      )}
      <Container fluid>
        <div className={styles.intro}>
          {precontent}
          {title && (
            <h1 className={classNames(styles.title, whiteText && styles.white)}>
              {title}
            </h1>
          )}
          {!!search && (
            <div className={styles.search}>
              <Input
                name="search"
                type="search"
                placeholder="Search"
                className={styles.searchInput}
                icon={<SvgSearch />}
                value={searchValue}
                onChange={handleSearch}
                searchValue={searchValue}
              />
            </div>
          )}
          {subtitle && (
            <h2
              className={classNames(styles.subtitle, whiteText && styles.white)}
            >
              {subtitle}
            </h2>
          )}
          {content}
        </div>
      </Container>
    </section>
  )
}

IntroBannerWithBackground.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  whiteText: PropTypes.bool,
  backgroundImage: PropTypes.element,
  content: PropTypes.element,
  search: PropTypes.bool,
}

export default IntroBannerWithBackground
